import { Col, Icon, Tappable, useTheme } from "@rally/ui-kit";

import { COMPOSER_ROW } from "./composer-state.ts";
import { dictationLabel } from "./dictation.ts";

export function Microphone({
  recording,
  level = 0,
  onPress,
  testID,
}: {
  recording: boolean;

  level?: number;
  onPress: () => void;
  testID: string;
}) {
  const theme = useTheme();
  return (
    <Tappable
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={dictationLabel(recording)}
      testID={testID}
      {...({
        "aria-pressed": recording,
        onMouseDown: (event: { preventDefault: () => void }) => event.preventDefault(),
      } as object)}
      style={{
        width: COMPOSER_ROW,
        height: COMPOSER_ROW,
        borderRadius: 999,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: recording ? theme.color.danger : theme.color["bg.surfaceAlt"],
      }}
    >
      {recording ? (
        <Col
          testID={`${testID}-level`}
          style={{
            position: "absolute",
            width: 12 + Math.round(Math.max(0, Math.min(1, level)) * 20),
            height: 12 + Math.round(Math.max(0, Math.min(1, level)) * 20),
            borderRadius: 999,
            backgroundColor: theme.color["text.onAccent"],
            opacity: 0.18,
          }}
        />
      ) : null}
      <Icon name="mic" size={16} color={recording ? "text.onAccent" : "text.secondary"} />
    </Tappable>
  );
}
